import cookie from 'js-cookie';

import { navigateToLoginPage } from 'services/routing';
import warehouse from 'services/warehouse';

import {
  USER_INFO_UPDATE,
  USER_INFO_REQUEST,
  USER_INFO_SUCCESS,
  USER_INFO_FAILURE,

  CUSTOMER_INFO_REQUEST,
  CUSTOMER_INFO_SUCCESS,
  CUSTOMER_INFO_FAILURE,
  CUSTOMER_INFO_UPDATE
} from './action-constants';

/**
 * USER INFO (logged in user)
 */
export const requestUserData = () => async (dispatch, getState) => {
  dispatch({
    type: USER_INFO_REQUEST
  });

  await warehouse.getUserInfo().then(responseData => {
    if (responseData.success) {
      dispatch({
        type: USER_INFO_SUCCESS,
        payload: responseData
      });
    } else {
      dispatch({
        type: USER_INFO_FAILURE
      });
    }
  });
};

export const updateUserData = userData => ({
  type: USER_INFO_UPDATE,
  payload: userData
});

export const updateCustomerData = customerData => ({
  type: CUSTOMER_INFO_UPDATE,
  payload: customerData
});

export const logoutUser = () => async (dispatch, getState) => {
  // Logout user on BE but do not wait for request to complete.
  // We do not expect any errors logging user out so swallow any errors.
  // In general, we can successfully logout the user client side by just deleting the JWT
  // cookie and updating local state.
  warehouse.logoutUser().then(() => {}).catch(() => {});

  // Always delete the JWT cookie
  cookie.remove('jwtToken');

  // Always update redux state to reflect user is logged out.
  dispatch({
    type: USER_INFO_SUCCESS,
    payload: {
      loggedIn: false
    }
  });

  // Always route user to login page
  navigateToLoginPage();
};

/**
 * CUSTOMER INFO (optional type of user, who is not logged in).
 * A customer can be different than the logged in user.
 * ex: If a user logs in as an admin "user" and views the page of a "customer".
*/
export const requestCustomerDataFrom = (userId) => async (dispatch, getState) => {
  dispatch({
    type: CUSTOMER_INFO_REQUEST
  });

  await warehouse.getCustomerInfoFrom(userId).then(responseData => {
    if (responseData.success) {
      const customerInfoData = customerInfoReducer(responseData);
      dispatch({
        type: CUSTOMER_INFO_SUCCESS,
        payload: customerInfoData
      });
    } else {
      dispatch({
        type: CUSTOMER_INFO_FAILURE
      });
    }
  });
};

/**
 * Reduces the amount data from the response to what we need to store in Redux.
 */
const customerInfoReducer = (response) => {
  const {
    id,
    first_name: firstName, // eslint-disable-line
    last_name: lastName, // eslint-disable-line
    email,
    phone,
    texting_enabled: textingEnabled
  } = response;

  return {
    id,
    firstName,
    lastName,
    email,
    phone,
    textingEnabled,
    userId: id
  };
};
